module.exports = __webpack_public_path__ + "static/media/medications-dizziness.ef59ce49.png";